<template>
    <div class="modal fade" :id="`historiesModal-${title}`" tabindex="-1" role="dialog" :aria-labelledby="`historiesModal-${title}`" aria-hidden="true" v-if="modalItem">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{ modalItem.title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    <p v-html="modalItem.description"></p>
                    <div class="photos d-flex" v-if="modalItem.images && modalItem.images.length">
                        <a class="photos__image" :href="'/storage' + image.path | convertImage('full')" v-for="(image) in modalItem.images"
                           :data-lightbox="'history-' + modalItem.id"
                           :style="'background-image: url(/storage' + image.path | convertImage('preview') + ')'">
                        </a>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Закрыть</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PetAndProjectHistoriesModal",
    props: ['modalItem', 'title'],
    data(){
        return{}
    },
    mounted(){
    }

}
</script>

<style lang="scss" scoped>

.photos {
    margin: 0 -5px;
    flex-wrap: wrap;


    &__image {
        width: calc(20% - 10px);
        height: 100px;
        margin: 5px;
        background: transparent no-repeat center/cover;
    }
}

@media screen and (max-width: 768px){
    .photos__image {
        width: calc(33.33% - 10px);
        height: 150px;
    }
}

@media screen and (max-width: 500px){
    .photos__image {
        width: calc(50% - 10px);
        height: 150px;
    }
}


</style>
